import { TFunction } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Badge, BadgeProps, BadgeType } from '@ui/components/Badge/Badge'

import { BankAccountStatus } from '@model/BankAccount'
import { NameDto } from '@model/NameDto'

interface DocumentBadgeStatusProps extends NameDto {
  type?: BankAccountStatus
}

type BankBadgeTypeMapType = Record<
  BankAccountStatus,
  { type: BadgeType; contrast: BadgeProps['contrast'] }
>

const BankBadgeTypeMap: BankBadgeTypeMapType = {
  [BankAccountStatus.None]: { type: 'danger', contrast: 'low' },
  [BankAccountStatus.AwaitingApproval]: { type: 'blue', contrast: 'low' },
  [BankAccountStatus.Approved]: { type: 'green', contrast: 'low' },
  [BankAccountStatus.Rejected]: { type: 'danger', contrast: 'low' },
  [BankAccountStatus.Expired]: { type: 'danger', contrast: 'low' },
  [BankAccountStatus.Activated]: { type: 'green', contrast: 'low' },
}

const getBankBadgeLabel = (status: BankAccountStatus, t: TFunction): string => {
  if (status === BankAccountStatus.None) {
    return t('Pending')
  } else if (status === BankAccountStatus.AwaitingApproval) {
    return t('AwaitingApproval')
  } else if (status === BankAccountStatus.Approved) {
    return t('Approved')
  } else if (status === BankAccountStatus.Rejected) {
    return t('Rejected')
  } else if (status === BankAccountStatus.Expired) {
    return t('Expired')
  } else {
    return t('Pending')
  }
}

export const BankBadgeStatus: React.FC<DocumentBadgeStatusProps> = (props) => {
  const { id } = props

  const { t } = useTranslation()
  const badgeConfig = BankBadgeTypeMap[id as BankAccountStatus]

  return (
    <Badge type={badgeConfig.type} contrast={badgeConfig.contrast} size='sm'>
      {getBankBadgeLabel(id, t)}
    </Badge>
  )
}
